import {createStore, applyMiddleware, compose} from "redux"
import Raven from "raven-js"
import createRavenMiddleware from "raven-for-redux"
import {responsiveStoreEnhancer} from "redux-responsive"
import thunkMiddleware from "redux-thunk"

import AuthActions from "@irati/auth/store/actions/AuthActions"

import rootReducer from "./reducers"

export default function configureStore() {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  /**
   * Middlewares, like `redux-thunk` that intercept or emit actions should precede `raven-for-redux`.
   */
  const store = createStore(
    rootReducer,
    composeEnhancers(
      responsiveStoreEnhancer,
      applyMiddleware(
        thunkMiddleware,
        createRavenMiddleware(Raven, {
          breadcrumbDataFromAction: (action) => ({STRING: action.str})
        })
      )
    )
  )

  if (window.Cypress) {
    window.__store__ = store
    // if a store action requires an API call, expose here
    window.__store_actions__ = {
      login: (args) => window.__store__.dispatch(AuthActions.login(...args)),
      logout: () => window.__store__.dispatch(AuthActions.logout())
    }
  }

  return store
}
